import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import storefrontImg from "../../assets/city-hardware-outside.png";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero">
      <div className="container hero__inner">
        {/* Left: Content */}
        <div className="hero__content">
          <div className="hero__eyebrow">
            <span className="hero__badge">Detroit, Michigan</span>
            <span className="hero__badge hero__badge--outline">Est. 1987</span>
          </div>

          <h1 className="hero__headline">
            Find <span className="hero__headline-accent">Everything</span>
            <span className="hero__headline"> For Home Repair</span>
            <span className="hero__headline-accent"> And More.</span>
          </h1>

          <p className="hero__sub">
            City Hardware is your local affordable, and reliable hardware store
            with a knack for window repair. Fast local fixes for cracked panes,
            drafty frames, and broken screens and more.
          </p>

          <div className="hero__cta-row">
            <Link to="/window-repair" className="hero__cta-primary">
              Get a Window Repair Quote
              <ArrowRight size={18} />
            </Link>
            <a href="tel:+13135828860" className="hero__cta-secondary">
              Ask About Window Repairs
            </a>
          </div>

          <div className="hero__trust-row">
            <span className="hero__trust-item">✓ Same-day quotes</span>
            <span className="hero__trust-item">✓ Local Detroit team</span>
            <span className="hero__trust-item">✓ Affordable pricing</span>
          </div>
        </div>

        {/* Right: Real storefront photo */}
        <div className="hero__visual">
          <div className="hero__image-wrap">
            <img
              src={storefrontImg}
              alt="City Hardware storefront in Detroit, Michigan"
              className="hero__photo"
            />

            {/* Floating stat cards */}
            <div className="hero__stat-card hero__stat-card--tl">
              <span className="hero__stat-num">35+</span>
              <span className="hero__stat-label">Years in Detroit</span>
            </div>
            <div className="hero__stat-card hero__stat-card--br">
              <span className="hero__stat-num">2,400+</span>
              <span className="hero__stat-label">Windows Repaired</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom search strip */}
      <div className="hero__search-strip">
        <div className="container hero__search-inner">
          <div className="hero__search-bar">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="hero__search-bar-icon">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="What can we help you find?"
              className="hero__search-input"
            />
            <button className="hero__search-btn">Search</button>
          </div>
          <div className="hero__chips">
            {[
              "Window Repair",
              "Glass Repair",
              "Lawn Tools",
              "Paint Supplies",
              "Key Cutting",
              "Power Tools",
              "Plumbing",
              "Screen Repair",
            ].map((chip) => (
              <button key={chip} className="hero__chip">
                {chip}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
